import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	finalOverview: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -110%)',
		width: '70vw !important',
		height: '70vh !important',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '3rem',
		overflow: 'scroll'
	}
}));
